// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weather-container {
  width: 100%;
  height: 40px;
  position: fixed;
  bottom: 0;
  right: 130px;
  z-index: 30;
  display: flex;
  justify-content: right;
  bottom: 24px;
  pointer-events: none;
  margin-right: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.weather-container-after-value {
  width: 100%;
  height: 40px;
  position: fixed;
  bottom: 0;
  right: 160px;
  z-index: 30;
  display: flex;
  justify-content: right;
  bottom: 23px;
  pointer-events: none;
  margin-right: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.weather-box-container {
  display: flex;
  width: 100px;
  height: 40px;
  pointer-events: all;
  background: #1D1D1D 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  overflow: hidden;
  transition: width 0.4s ease;
}

.weather-box-container-after-value {
  display: flex;
  width: 50px;
  height: 40px;
  pointer-events: all;
  background: #1D1D1D 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  cursor: pointer;
}


.weather-content {
  /* width: 26px; */
  height: 30px;
  text-align: center;
  font: normal normal normal 20px/30px Oswald;
  letter-spacing: -0.6px;
  color: #C6C4C4;
  opacity: 1;
}

.cloud-icon {
  width: 35px;
  height: 40px;
}

.weather-value-container {
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.clouds-continer {
  width: 50%;
  display: flex;
  justify-content: center;
}

.clouds-continer-after-value {
  width: 100%;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/component/map/weather/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;;AAGA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;EACtB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".weather-container {\n  width: 100%;\n  height: 40px;\n  position: fixed;\n  bottom: 0;\n  right: 130px;\n  z-index: 30;\n  display: flex;\n  justify-content: right;\n  bottom: 24px;\n  pointer-events: none;\n  margin-right: 10px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.weather-container-after-value {\n  width: 100%;\n  height: 40px;\n  position: fixed;\n  bottom: 0;\n  right: 160px;\n  z-index: 30;\n  display: flex;\n  justify-content: right;\n  bottom: 23px;\n  pointer-events: none;\n  margin-right: 10px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.weather-box-container {\n  display: flex;\n  width: 100px;\n  height: 40px;\n  pointer-events: all;\n  background: #1D1D1D 0% 0% no-repeat padding-box;\n  border-radius: 5px;\n  opacity: 1;\n  overflow: hidden;\n  transition: width 0.4s ease;\n}\n\n.weather-box-container-after-value {\n  display: flex;\n  width: 50px;\n  height: 40px;\n  pointer-events: all;\n  background: #1D1D1D 0% 0% no-repeat padding-box;\n  border-radius: 5px;\n  opacity: 1;\n  cursor: pointer;\n}\n\n\n.weather-content {\n  /* width: 26px; */\n  height: 30px;\n  text-align: center;\n  font: normal normal normal 20px/30px Oswald;\n  letter-spacing: -0.6px;\n  color: #C6C4C4;\n  opacity: 1;\n}\n\n.cloud-icon {\n  width: 35px;\n  height: 40px;\n}\n\n.weather-value-container {\n  width: 40%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.clouds-continer {\n  width: 50%;\n  display: flex;\n  justify-content: center;\n}\n\n.clouds-continer-after-value {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
